
export const CONFIGPOS = 'sqdczhc'; // pos 模块

export const receiveBtn = '//s.qunarzz.com/vacation_tuan/2020/06_shuchu/receive_btn_v2.png';

export const receiveSuccessBtn = '//s.qunarzz.com/vacation_tuan/2020/06_shuchu/receive_success_v2.png';